module.exports = __webpack_public_path__ + "img/wrong.49a6041a.svg";